// Implements: F-UIX-010, F-UIX-018
/**
 * A rate limit, shown as a wait (UIX.2). Pure presentation.
 *
 * `role="status"`, not an alert: a `429` is the system saying "in a moment", not "it went
 * wrong". The seconds arrive already counted down (`useRateLimitWait`); the control that sends
 * stays disabled meanwhile, and this sentence is the reason on screen.
 *
 * The live region holds a sentence that does not change, so a screen reader announces the
 * wait once; the ticking number is a separate `aria-hidden` line for the eyes only.
 */

import type { ReactElement } from "react";

import { useTranslation } from "../../i18n";
import styles from "./RateLimitWait.module.css";

export interface RateLimitWaitProps {
  /** Seconds still to wait. */
  readonly seconds: number;
}

export function RateLimitWait({ seconds }: RateLimitWaitProps): ReactElement {
  const { t } = useTranslation();
  return (
    <div className={styles.wait}>
      <p className={styles.line} role="status">
        {t("common.state.rateLimitWaitStatus")}
      </p>
      <p className={styles.line} aria-hidden="true">
        {t("common.state.rateLimitWait", { seconds })}
      </p>
    </div>
  );
}
